export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export function throttle(func, limit) {
  let inThrottle;
  return function executedFunction(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

export function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = String(text);
  return div.innerHTML;
}

export function formatDateTime(value, locale = 'ru-RU') {
  if (!value) return '—';
  try {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleString(locale);
  } catch (error) {
    console.warn('formatDateTime error:', error);
    return '—';
  }
}

export function normalizeTeamId(raw) {
  if (!raw) return null;
  const value = String(raw).trim().toUpperCase();
  if (value === 'A' || value === 'TEAM_A' || value === 'TEAM-A') return 'A';
  if (value === 'B' || value === 'TEAM_B' || value === 'TEAM-B') return 'B';
  return null;
}
